import { Button } from '@app/components/ui';
import useTranslation from '@app/hooks/use-translation';
import React from 'react';

const UnsubscribeFromReportError = () => {
  const { t } = useTranslation('common.emailConfirmation');
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="bg-white p-[40px] shadow-hard rounded-[10px] w-[409px] flex flex-col gap-[30px]">
        <div className="flex flex-col gap-[15px]">
          <span className="text-0color text-[22px] font-[700] text-center">
            {t('report.title_err')}
          </span>
          <span className="text-center text-3color text-[16px]">{t('report.description_err')}</span>
        </div>
        <div className="flex self-center">
          <Button link="/" label={t('button_label')} />
        </div>
      </div>
    </div>
  );
};

export default UnsubscribeFromReportError;
